"use client";

import { useEffect, useState } from "react";
import { asuncionTime } from "@/lib/asuncion";
import { rainLevel } from "@/lib/weather";
import { worldBus } from "@/lib/world-bus";

type Weather = { tempC: number; label: string };

// El servidor guarda el clima 15 minutos: pedirlo más seguido no trae nada nuevo.
const WEATHER_REFRESH_MS = 15 * 60 * 1000;

// "Asunción · 23:41 · 24 °C · llovizna": la hora de Asunción (no la del visitante) y el
// clima real. El clima lo consulta el servidor del sitio y se sirve desde /api/clima:
// el navegador nunca habla con terceros (guía 15). Si no hay datos, no se muestra.
// El mismo dato le dice a la escena si llueve (02-EASTER-EGGS.md, 4); sin datos, seco.
export function AsuncionNow({ className }: { className?: string }) {
  const [time, setTime] = useState<string | null>(null);
  const [weather, setWeather] = useState<Weather | null>(null);

  useEffect(() => {
    const tick = () => setTime(asuncionTime(new Date()));
    tick();
    const id = window.setInterval(tick, 15000);
    const ctrl = new AbortController();
    const load = () =>
      fetch("/api/clima", { signal: ctrl.signal })
        .then((r) => (r.ok ? r.json() : null))
        .then((d: { ok: boolean; tempC?: number; label?: string } | null) => {
          if (d?.ok && typeof d.tempC === "number" && d.label) {
            setWeather({ tempC: d.tempC, label: d.label });
            worldBus.rain = rainLevel(d.label);
          } else {
            worldBus.rain = 0;
          }
        })
        .catch(() => undefined);
    void load();
    const wid = window.setInterval(() => void load(), WEATHER_REFRESH_MS);
    return () => {
      window.clearInterval(id);
      window.clearInterval(wid);
      ctrl.abort();
    };
  }, []);

  return (
    <p className={className}>
      <span>Asunción</span>
      {time && <span> · {time}</span>}
      {weather && (
        <span>
          {" "}
          · {weather.tempC} °C · {weather.label}
        </span>
      )}
    </p>
  );
}
